import React from "react";
import {Row, Col, FormGroup, Form} from "react-bootstrap";
import {translate} from '../../i18n/translate.js';
import style from "../../css/account/accountReportsPane.less";

export const AccountReportsPane = props => {
    const subscriptionSummary = props.subscriptionSummary;
    return (<Form className="account-reports-container">
        {props.clientViewPort.isXs ?
            <div className="account-header-title-container">
                <div className="account-header-title">{translate("Reports")}</div>
            </div> : undefined}
        <FormGroup className="account-reports-inner-container">
            {
                !subscriptionSummary.pickupSiteReporURL ? undefined :
                    <Row>
                        <Col md={12}>
                            <a className="report-row" target="_blank"
                               href={subscriptionSummary.pickupSiteReporURL}>{translate("Member Pick-up details")}</a>
                        </Col>
                    </Row>
            }
            {
                !subscriptionSummary.contactListReportURL ? undefined :
                    <Row>
                        <Col md={12}>
                            <a className="report-row" target="_blank"
                               href={subscriptionSummary.contactListReportURL}>{translate("Member Contact Info")}</a>
                        </Col>
                    </Row>
            }
            {
                !subscriptionSummary.contactListReportURL ? undefined :
                    <Row>
                        <Col md={12}>
                            <a className="report-row" target="_blank"
                               href={subscriptionSummary.contactListReportURL + "&includeSubscriptions=true"}>{translate("Member Share Details")}</a>
                        </Col>
                    </Row>
            }
            {
                !subscriptionSummary.orderDistributionReporURL ? undefined :
                    <Row>
                        <Col md={12}>
                            <a className="report-row"
                               href={subscriptionSummary.orderDistributionReporURL ? subscriptionSummary.orderDistributionReporURL : ""}>
                                {translate("_StoreOrderDistribution")}</a>
                        </Col>
                    </Row>
            }
        </FormGroup>
    </Form>);
};



// WEBPACK FOOTER //
// ./src/components/account/AccountReportsPane.js